import { render, staticRenderFns } from "./SearchDropdownElement.vue?vue&type=template&id=1d23b3a8&"
import script from "./SearchDropdownElement.vue?vue&type=script&lang=js&"
export * from "./SearchDropdownElement.vue?vue&type=script&lang=js&"
import style0 from "./SearchDropdownElement.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports